export default {
      id: "horaires-usage",
      viewBox: "0 0 370 370",
      url: "../dist/images/" + "sprite.svg#horaires-usage",
      toString: function () {
        return this.url;
      }
    }